import Entity from './entity'
export default class User extends Entity<number>{
    password: string;
    mobile: string;
    userType: string;
    userIdentityType: string;
    schoolId: number;
    currentClasses: any;
    birthdayToString: string;
    qq: string;
    weChat: string;
    gender: string;
    isShowHomepageName:boolean;
    name:string;
    roleType:string;
    grantedPermissions:string[];
    grantedResours:number[];
    grantedQuestions:number[];
    geachingSubjectId:number;
    educationConcept:string;
    roleId:number;
}